export default {
    // 判断是医生端还是医助端
    getHttpUrl(doctorUrl, zhuliUrl) {
        let url = '';
        if (localStorage.getItem('userType') == 1) {
            url = doctorUrl;
        } else if (localStorage.getItem('userType') == 2) {
            url = zhuliUrl;
        }
        return url;
    },
};
